@if (meetingableId) {
  <app-meeting-record
    [meetingableType]="meetingableType"
    [meetingableId]="meetingableId"
    [meetingRecordId]="meetingRecordId"
    [onSaveRoute]="'/employees/direction/users/' + meetingableId + '/meeting-records/:meeting_record_id'"
    [onBackRoute]="'/employees/direction/users/' + meetingableId + '/meeting-records'"
  >
  </app-meeting-record>
}
